export default "__VITE_ASSET__9b0a26ea__"